export default __webpack_public_path__ + "static/media/(99).c07bec08.jpg";